import { r } from "./register-RPRadFEG.js";
import { L as t } from "./register-RPRadFEG.js";
r();
export {
  t as LanguageSwitch
};
